import { useEffect, useState } from 'react';
import externalApiAxios from '../utils/axiosHelper';

const SEARCH_RADIUS = 25000;

const select = ({ data }) => data.map((program) => {
  const { document, id, relationships } = program;
  return {
    ...document,
    id,
    provider: {
      name: relationships.provider.data.document.name,
      name_untranslated: relationships.provider.data.document.name_untranslated,
      phone_numbers: relationships.provider.data.document.phone_numbers,
      email_addresses: relationships.provider.data.document.email_addresses,
      website_url: relationships.provider.data.document.website_url,
      hours: relationships.provider.data.document.hours,
    },
    service_areas: relationships.service_areas?.data?.map((SA) => SA.document),
    fee_schedule_program: relationships.fee_schedule_program,
  };
}).sort((a, b) => {
  if (a.service_areas) {
    return 1;
  }
  if (b.service_areas) {
    return -1;
  }
  return 0;
});

const useProgramsFromSearchApi = (programIds, groupIds, lat, lon, locale = 'en') => {
  if (programIds.length && groupIds.length) {
    throw new Error('program ids and group ids cannot be fetched togehter.');
  }
  if (!programIds.length && !groupIds.length) {
    throw new Error('no ids to fetch!');
  }
  const [data, setData] = useState();
  const [isFetching, setIsFetching] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const getProgramsFromSearch = async () => {
      if (data || isFetching || isError) {
        return;
      }

      setIsFetching(true);
      setIsError(false);

      const params = new URLSearchParams({
        'filter[include_payments]': true,
        include: 'provider, service_areas, fee_schedule_program',
      });
      
      params.append('filter[provider.type]', 'all');

      if (programIds.length) {
        params.append('filter[id]', programIds.toString());
      } else if (groupIds.length) {
        params.append('filter[provider]', groupIds.toString());
      }

      if (lat && lon) {
        params.append('filter[locations][radius][latitude]', lat);
        params.append('filter[locations][radius][longitude]', lon);
        params.append('filter[locations][radius][distance]', SEARCH_RADIUS);
        params.append('filter[locations][include_no_location]', true);
        params.append('sort', 'distance');
      }
      if (locale !== 'en') {
        params.append('locale', locale);
      }

      const url = `/programs?${params.toString()}`;

      try {
        const response = await externalApiAxios.get(url);
        const parsedData = select(response.data);
        setData(parsedData);
      } catch (error) {
        window.DD_RUM?.addError(
          Object.assign(error, { message: `[Shares] error fetching programs : ${error.message}` }),
        );
        setIsError(true);
      } finally {
        setIsFetching(false);
      }
    };

    getProgramsFromSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programIds, locale]);

  return { data, isLoading: !(data || isError), isError };
};

export default useProgramsFromSearchApi;
